import { takeLatest, call, put } from "redux-saga/effects";
import {
  partnerUpdated,
  PARTNER_UPDATE_REQUEST,
  partnerUpdateError,
} from "../../actions/partners";
import updatePartner from "../../../../../backend/oncall/administration/partners/update";

const requestUpdate = function*(action) {
  try {
    yield call(
      updatePartner,
      parseInt(action.payload.partnerId, 10),
      action.payload.formData.name,
      parseInt(action.payload.formData.internalId, 10),
      action.payload.formData.enabled,
    );
    yield put(partnerUpdated());
  } catch (error) {
    yield put(partnerUpdateError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNER_UPDATE_REQUEST, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/request-update.js